export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.26-1403.01",
  commitId: "312a6330ff35380a50ed428342869e02c8fc5734",
  commitTime: "2026-05-26T14:03:01.000Z",
});
